module.exports = __webpack_public_path__ + "static/media/fatigue-white.5888a20c.svg";